module.exports = __webpack_public_path__ + "static/media/990740.4a7c00da.png";